import { Component, Mixins } from 'vue-property-decorator';
import { MagicConfigMixin } from '@gig/magic-common';
import '@gig/magic-messaging';

@Component({
    name: 'live-chat',
})
export default class LiveChatComponent extends Mixins(MagicConfigMixin) {}
